module.exports = {"510117001":"郫筒街道","510117019":"合作街道","510117020":"西园街道","510117101":"团结镇","510117102":"犀浦镇","510117103":"花园镇","510117104":"唐昌镇","510117105":"安德镇","510117106":"三道堰镇","510117107":"安靖镇","510117108":"红光镇","510117110":"新民场镇","510117112":"德源镇","510117115":"友爱镇","510117117":"古城镇","510117118":"唐元镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510117.json
// module id = 2263
// module chunks = 0